import { SET_ALL_DEALS } from '../mutationTypes';

const moduleDeals = {
  namespaced: true,

  state: {
    allDeals: [],
  },

  getters: {

  },

  actions: {

  },

  mutations: {
    [SET_ALL_DEALS](state, allDeals) {
      state.allDeals = allDeals;
    },
  },
};

export default moduleDeals;
